import React from "react";
import DashboardPage from "./DashboardPage";
import SafeView from "../../components/safeView/SafeView";

const Dashboard = () => {
  return (
    <SafeView>
      <DashboardPage />
    </SafeView>
  );
};

export default Dashboard;
